import { versionGateway } from '~/gateways/versionGateway';
import { MagicUseCase } from './magicUseCase';

export class GetVersionsUseCase extends MagicUseCase {
  protected async runLogic() {
    try {
      const version = await versionGateway.getVersion();
      this.getState().user.version = { ...version, isReachable: true };
    } catch {
      this.getState().user.version = { isReachable: false };
    }
  }
}
